import * as React from 'react';
import { classNames, useUitkContext } from 'uitk-react-utils';
import styles from './uitk-action-list-item.css';

var getClassNameList = classNames.bind(styles);
var UitkActionListItemLink = function (props) {
    var children = props.children, visuallyHideLinkText = props.visuallyHideLinkText;
    var contextData = useUitkContext().data;
    var contextAriaDesc = (contextData !== null && contextData !== void 0 ? contextData : {}).contextAriaDesc;
    var childrenArray = React.Children.toArray(children);
    var firstChild = childrenArray[0];
    var randomId = Math.random().toString(36).substring(7);
    var uniqueSpanId = "selector-description-".concat(randomId);
    // Defines the span that provides description
    var AriaDescription = function () {
        if (contextAriaDesc) {
            return (React.createElement("span", { className: "is-visually-hidden", id: uniqueSpanId }, contextAriaDesc));
        }
        return React.createElement(React.Fragment, null);
    };
    if (!childrenArray || childrenArray.length !== 1) {
        console.warn("UitkActionListItemLink uses the first child element. ".concat(childrenArray.length, " children found."));
        return null;
    }
    var decoratedFirstChild = React.cloneElement(firstChild, {
        className: getClassNameList(firstChild.props.className, 'uitk-action-list-item-link', !visuallyHideLinkText && "uitk-action-list-item-link-has-visible-text"),
        'aria-describedby': contextAriaDesc ? uniqueSpanId : ''
    }, visuallyHideLinkText ? (React.createElement("span", { className: "is-visually-hidden" },
        React.createElement(AriaDescription, null),
        firstChild.props.children)) : (React.createElement(React.Fragment, null,
        React.createElement(AriaDescription, null),
        firstChild.props.children)));
    return decoratedFirstChild;
};
UitkActionListItemLink.defaultProps = {
    visuallyHideLinkText: true
};
UitkActionListItemLink.displayName = 'UitkActionListItemLink';

export { UitkActionListItemLink };
